import { Injectable } from '@angular/core';
import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Router } from '@angular/router';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { AuthService } from '../components/services/auth.service';
import { environment } from '../../environments/environment';

// Attaches the JWT from the signed-in user to every call to our API, and sends the
// user back to sign in (returning to the same page) when the API rejects the session —
// e.g. a token that expired, or a session saved before tokens existed.
@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {
  // Endpoints where a 401 means "wrong credentials", not "session expired".
  private static readonly AUTH_ENDPOINTS = /users\/(authenticate|register|sociallogin)/i;

  constructor(private authService: AuthService, private router: Router) {}

  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const isApiCall = req.url.startsWith(environment.apiUrl);
    const token = (this.authService.getCurrentUser() as any)?.token;

    const outgoing = isApiCall && token
      ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
      : req;

    return next.handle(outgoing).pipe(
      catchError((err: HttpErrorResponse) => {
        if (isApiCall && err.status === 401 && !AuthTokenInterceptor.AUTH_ENDPOINTS.test(req.url)) {
          this.authService.logout();
          const returnUrl = this.router.url.startsWith('/auth') ? undefined : this.router.url;
          this.router.navigate(['/auth'], { queryParams: returnUrl ? { returnUrl } : {} });
        }
        return throwError(() => err);
      })
    );
  }
}
